export default __webpack_public_path__ + "static/media/autofollow-status@3x.60fa92c1.png";